import React from 'react';
import { createPortal } from 'react-dom';
import translate from '@/utils/translate';

const ConfirmationModal = ({
    isOpen,
    onConfirm,
    onCancel,
    onClose,
    title = translate('Confirm'),
    message = translate('Are you sure'),
    confirmText = translate('Yes'),
    cancelText = translate('Cancel'),
}) => {
    if (!isOpen) return null;

    const handleOverlayClick = () => {
        if (onClose) {
            onClose();
        }
    };

    return createPortal(
		// <div className="confirmation-overlay" onClick={handleOverlayClick}>
        <div className="confirmation-overlay">
            <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
                <div className="confirmation-modal__header">
                    <h5 className="confirmation-modal__title">{title}</h5>
                    <button
                        className="confirmation-modal__close"
                        onClick={onClose}
                        aria-label={translate('Close')}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div className="confirmation-modal__body">
                    <p>{message}</p>
                </div>
                <div className="confirmation-modal__footer">
                    <button className="btn btn-sm btn-outline-light" onClick={onCancel}>
                        {cancelText}
                    </button>
                    <button className="btn btn-sm btn-danger ms-2" onClick={onConfirm}>
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ConfirmationModal;